import { hasWritePermission } from "../../PermissionUtility";

export default function emailConfigurationFormInputs(values) {
  const canWriteUsers = hasWritePermission('primary_email');

  return [
    {
      shape: "div",
      type: "wrapper",
      className: "",
      sx: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gridColumnGap: "100px",
        mt: 3,
      },
      children: [         
        {
          shape: "input",
          type: "email",
          name: "primary_email",
          title: "Primary Email",
          label: "Primary Email",
          className: "",
          placeholder: "Enter primary email address",
          width: '100%',
          validation: {
            required: true,
            requiredMessage: "Primary Email is required",
            pattern: {
              value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
              message: "Please enter a valid email address"
            }
          }
        },          
        {
          shape: "input",
          type: "email",
          name: "secondary_email",
          title: "Secondary Email",
          label: "Secondary Email (Optional)",
          className: "",
          placeholder: "Enter secondary email address",
          width: '100%',
          validation: {
            validEmail: (value) => {
                if (!value || value.trim() === '') return true;
                
                const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                console.log(emailRegex, "emailRegex")
                return emailRegex.test(value) || "Please enter a valid email address";
              }
          }
        }
      ],
    },
    {
      shape: "div",
      type: "wrapper",
      className: "",
      sx: { 
        display: "flex", 
        justifyContent: "flex-start", 
        mt: 4 
      },
      children: [
        ...(canWriteUsers ? [{
          shape: "button",
          type: "action",
          title: values.mode === "view" ? "Edit" : values.isupdate ? "Update" : "Save",
          submitButton: true,
          name: "Save",
          sx: {
            px: 4,
          },
          validation: {
            hiddenRules: [
              {
                mode: "view",
              },
            ],
          },
        }] : []),
      ],
    },
  ];
}